<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="v" class="page" epub:type="pagebreak" id="pv" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfmf"><a class="xref" href="#/chibentley0007#abbrs">List of Abbreviations</a></p>
<p class="tocf"><a class="xref" href="#/chibentley0008#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/chibentley0009#ch01"><span class="sm">ONE</span>  “Un théâtre est une machine difficile à mouvoir”: Developing a Transatlantic Cultural Institution</a></p>
<p class="toc"><a class="xref" href="#/chibentley0010#ch02"><span class="sm">TWO</span>  Transatlantic Production and Transatlantic Reception: Positioning New Orleans through <i>Grand Opéra</i></a></p>
<p class="toc"><a class="xref" href="#/chibentley0011#ch03"><span class="sm">THREE</span>  Audiences and Publics: Opera in the Sociocultural Fabric of New Orleans</a></p>
<p class="toc"><a class="xref" href="#/chibentley0012#ch04"><span class="sm">FOUR</span>  Opera’s Material Culture and the Creation of Global Intimacy</a></p>
<p class="toc"><a class="xref" href="#/chibentley0013#ch05"><span aria-label="vi" class="page" epub:type="pagebreak" id="pvi" role="doc-pagebreak"></span><span class="sm">FIVE</span>  Reimagining New Orleans in Operatic Travelogues</a></p>
<p class="toc"><a class="xref" href="#/chibentley0014#epil"><span class="sm">EPILOGUE</span>  From the Transatlantic to the Global: Beyond the Théâtre d’Orléans</a></p>
<p class="tocbmf"><a class="xref" href="#/chibentley0015#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chibentley0016#au_note">Author’s Note</a></p>
<p class="tocbm"><a class="xref" href="#/chibentley0017#app1">Appendices</a></p>
<p class="tocbm"><a class="xref" href="#/chibentley0019#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chibentley0021#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chibentley0022#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-bentley-0006.vue?0fffc959